var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 0.6875C16.375 0.90625 16.5312 1.28125 16.4375 1.6875L14.4375 14.6562C14.4062 14.9688 14.2188 15.25 13.9375 15.375C13.8438 15.4375 13.6562 15.5 13.4688 15.5C13.3438 15.5 13.2188 15.5 13.0625 15.4375L9.31245 13.875L6.62495 16.4375C6.5937 16.5 6.5312 16.5 6.4687 16.5C6.4062 16.5 6.31245 16.4688 6.24995 16.3438L4.31245 11.75L1.0937 10.4062C0.749953 10.25 0.499953 9.90625 0.499953 9.5625C0.468703 9.1875 0.656203 8.84375 0.999953 8.625L15 0.65625C15.1562 0.5625 15.3125 0.5 15.5 0.5C15.6875 0.5 15.875 0.5625 16.0625 0.6875ZM1.49995 9.5L4.3437 10.7188L13.375 2.71875L1.49995 9.5ZM6.74995 14.9688L8.37495 13.4062L7.31245 12.9688C7.1562 12.9375 7.06245 12.8125 6.99995 12.6562C6.9687 12.5 6.99995 12.3438 7.0937 12.2188L12.375 4.9375L5.2187 11.2812L6.74995 14.9688ZM13.5 14.375L15.3125 2.59375L8.2812 12.2812L13.5 14.375Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "assets/edbdaf130da818551430ed50c6198590.svg";
export { SvgPaperPlane as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/paper-plane.svg